var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHarness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.82,
    height: 24.5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-harness_svg__mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-harness_svg__path_1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v22.953H0V0z",
    id: "icon-harness_svg__path_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-harness_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-harness_svg__mask_1)",
    transform: "translate(3.5 .95)",
    id: "icon-harness_svg__icon-harness"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-harness_svg__Group_663",
    transform: "translate(.703 .704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.108 17.023a4.524 4.524 0 10-9.048 0 4.524 4.524 0 009.048 0h0z",
    id: "icon-harness_svg__Path_3952",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.555 1.984a1.985 1.985 0 10-3.97.002 1.985 1.985 0 003.97-.002h0z",
    id: "icon-harness_svg__Path_3953",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-harness_svg__Group",
    transform: "translate(4.584 7.783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.705L12.01 0",
    id: "icon-harness_svg__Path_3954",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.07 4.004C3.185 5.727 0 8.675 0 10.056c0 1.381 5.351-2.323 8.837.987",
    id: "icon-harness_svg__Path_3955",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.286 6.066a5.527 5.527 0 014.419 1.397",
    id: "icon-harness_svg__Path_3956",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIconHarness as ReactComponent };